module.exports = __webpack_public_path__ + "static/media/unionpay.62fb4f77.svg";